import Swal from "sweetalert2"

let _darkMode = false

const style = document.createElement("style")
style.textContent = ".swal-toast-offset { top: 80px !important; }"
document.head.appendChild(style)

export const updateSwalDarkMode = (isDark) => {
  _darkMode = isDark
}

export const showToast = ({ title, text, icon }) => {
  return Swal.fire({
    toast: true,
    position: "top-end",
    icon,
    title,
    text,
    showConfirmButton: false,
    timer: 5000,
    timerProgressBar: true,
    background: _darkMode ? "#1a2035" : "#ffffff",
    color: _darkMode ? "#ffffffcc" : "#344767",
    customClass: { container: "swal-toast-offset" },
  })
}
